import {NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {AppSharedModule} from './appSharedModule/app-shared.module';
import {LoginComponent} from './components/login/login.component';
import {SideBarComponent} from './components/bars/side-bar/side-bar.component';
import {TopbarComponent} from './components/bars/topbar/topbar.component';
import {CartWidgetComponent} from './components/cart/cart-widget/cart-widget.component';
import {CartComponent} from './components/cart/cart.component';
import {CartConfirmationComponent} from './components/cart/cart-confirmation/cart-confirmation.component';
import {CartAddpEditDialogComponent} from './components/cart/cart-addp-edit-dialog/cart-addp-edit-dialog.component';
import {HomeComponent} from './components/home/home.component';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {PageNotFoundComponent} from './components/page-not-found/page-not-found.component';
import {AuthenticationService} from './authenticationModule/services/authentication.service';
import {LoaComponent} from './components/loa/loa.component';
import {TableModule} from 'primeng/table';
import {DatePipe} from '@angular/common';
import {ApiModule, BwGraphUserConfigsService, Configuration, ConfigurationParameters} from './generated';
import {environment} from '../environments/environment';
import {CardModule} from 'primeng/card';
import {PanelModule} from 'primeng/panel';
import {QuestionableBooleanPipe} from './share/pipes/questionable-boolean/questionable-boolean.pipe';
import {LongNumberPipe} from './share/pipes/long-number.pipe';
import {DropdownModule} from 'primeng/dropdown';
import {ButtonModule} from 'primeng/button';
import {CheckboxModule} from 'primeng/checkbox';
import {FileUploadModule} from 'primeng/fileupload';
import {BwSchedulesComponent} from './components/bw-schedules/bw-schedules.component';
import {BwEtreeOverviewComponent} from './components/bw-etree-overview/bw-etree-overview.component';
import {QuincyEtreesListComponent} from './components/quincy-etrees-list/quincy-etrees-list.component';
import {QuincyEtreeOverViewComponent} from './components/quincy-etree-over-view/quincy-etree-over-view.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {BaseClientComponent} from './components/base-client.component';
import {QedSymbolDataComponent} from './components/qed-symbol-data/qed-symbol-data.component';
import {PopTrigramComponent} from './components/commercial-pops/pop-trigram/pop-trigram.component';
import {TabViewModule} from 'primeng/tabview';
import {TabMenuModule} from 'primeng/tabmenu';
import {QedMulticastListComponent} from './components/qed-multicast-list/qed-multicast-list.component';
import {QrdSymbolDataComponent} from './components/qrd-symbol-data/qrd-symbol-data.component';
import {QrdMulticastListComponent} from './components/qrd-multicast-list/qrd-multicast-list.component';
import {QrdProductInformationComponent} from './components/qrd-product-information/qrd-product-information.component';
import {ImpersonateUserComponent} from './components/impersonate-user/impersonate-user.component';
import {DownloadLogComponent} from './components/download-log/download-log.component';
import {WeatherMapComponent} from './components/weather-map/weather-map.component';
import {DocumentsComponent} from './components/documents/documents.component';
import {DocumentCrudComponent} from './components/document-crud/document-crud.component';
import {NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown';
import {ChangePasswordComponent} from './components/change-password/change-password.component';
import {NotAllowedPermissionsDirective} from './authenticationModule/directives/not-allowed-permissions.directive';
import {PasswordStrengthComponent} from './components/password-strength/password-strength.component';
import {ForgotPasswordComponent} from './components/forgot-password/forgot-password.component';
import {ResetPasswordComponent} from './components/reset-password/reset-password.component';
import {
  EmailChangeConfirmationComponent
} from './components/email-change-confirmation/email-change-confirmation.component';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {ListUsersComponent} from './components/list-user/list-user.component';
import {EncryptionKeysComponent} from './components/encryption-keys/encryption-keys.component';
import {EncryptionKeysLogsComponent} from './components/encryption-keys-logs/encryption-keys-logs.component';
import {
  RequestHistoricalDataComponent
} from './components/historical-data/request-historical-data/request-historical-data.component';
import {HistoryRequestService} from './generated/api/history-request.service';
import {ListClientsComponent} from './components/list-clients/list-clients.component';
import {CompanyService} from './generated/api/company.service';
import {UserCrudComponent} from './components/user-crud/user-crud.component';
import {ClientCrudComponent} from './components/client-crud/client-crud.component';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {MultiSelectModule} from 'primeng/multiselect';
import {TreeSelectModule} from 'primeng/treeselect';
import {SpinnerModule} from 'primeng/spinner';
import {FieldsetModule} from 'primeng/fieldset';
import {ChartModule} from 'primeng/chart';
import {ToggleButtonModule} from 'primeng/togglebutton';
import {CalendarModule} from 'primeng/calendar';
import {SelectButtonModule} from 'primeng/selectbutton';
import {RadioButtonModule} from 'primeng/radiobutton';
import {OverlayPanelModule} from 'primeng/overlaypanel';
import {SidebarModule} from 'primeng/sidebar';
import {ToolbarModule} from 'primeng/toolbar';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {InputTextModule} from 'primeng/inputtext';
import {PaginatorModule} from 'primeng/paginator';
import {ConfirmationService} from 'primeng/api';
import {DialogService, DynamicDialogModule} from 'primeng/dynamicdialog';
import {EditorModule} from 'primeng/editor';
import {DocumentNotificationComponent} from './components/document-notification/document-notification.component';
import {DownloadDocumentComponent} from './components/download-document/download-document.component';
import {AnnouncementLogComponent} from './components/announcement-log/announcement-log.component';
import {ListRecipientsComponent} from './components/list-recipients/list-recipients.component';
import {
  AcknowledgedDomainConfirmationComponent
} from './components/acknowledged-domain-confirmation/acknowledged-domain-confirmation.component';
import {QedProfileComponent} from './components/qed-profile/qed-profile.component';
import {DadReportingModule} from './dad-reporting/dad-reporting.module';
import {InformationComponent} from './components/information/information.component';
import {BandwidthSummaryComponent} from './components/bandwidth-summary/bandwidth-summary.component';
import {MarketDataSummaryComponent} from './components/market-data-summary/market-data-summary.component';
import {AdminEncryptionKeysComponent} from './components/admin-encryption-keys/admin-encryption-keys.component';
import {BwGraphListComponent} from './components/bw-graph/bw-graph-list/bw-graph-list.component';
import {BwGraphCrudComponent} from './components/bw-graph/bw-graph-crud/bw-graph-crud.component';
import {
  HistoricalDataRequestLogComponent
} from './components/historical-data/historical-data-request-log/historical-data-request-log.component';
import {PGroupMultiselectComponent} from './components/p-group-multiselect/p-group-multiselect.component';
import {TooltipModule} from 'primeng/tooltip';
import {EtreesCountersLiveComponent} from './components/etrees-counters-live/etrees-counters-live.component';
import {CountersMqttComponent} from './components/counters-mqtt/counters-mqtt.component';
import {SymbolDataDownloadLogComponent} from './components/symbol-data-download-log/symbol-data-download-log.component';
import {MfaComponent} from './components/mfa/mfa.component';
import {MdAvailabilityComponent} from './components/commercial-pops/md-availability/md-availability.component';
import {BwAvailabilityComponent} from './components/commercial-pops/bw-availability/bw-availability.component';
import {AuthenticatorSetupComponent} from './components/connect-mfa/authenticator-setup.component';
import {CodeInputModule} from 'angular-code-input';
import {NgxSpinnerModule} from 'ngx-spinner';
import {BwServiceMapComponent} from './components/commercial-pops/bw-service-map/bw-service-map.component';
import {MdServiceMapComponent} from './components/commercial-pops/md-service-map/md-service-map.component';
import {ServiceMapComponent} from './components/commercial-pops/service-map/service-map.component';
import {NgxDaterangepickerMd} from 'ngx-daterangepicker-material';
import {MessageDialogComponent} from './components/message-dialog/message-dialog.component';
import {
  ManageInvoiceRecipientsComponent
} from './components/manage-invoice-recipients/manage-invoice-recipients.component';
import {ViewAnnouncementComponent} from './components/view-announcement/view-announcement.component';
import {BwGraphEndToEndComponent} from './components/bw-graph/bw-graph-end-to-end/bw-graph-end-to-end.component';
import {
  MarketDataQrdMlrLatencyComponent
} from './components/bw-graph/market-data-qrd-mlr-latency/market-data-qrd-mlr-latency.component';
import {
  MarketDataPlrLatencyGraphComponent
} from './components/bw-graph/market-data-plr-latency-graph/market-data-plr-latency-graph.component';
import {RoleService} from './services/role.service';
import {LoaService} from './services/loa.service';
import {BinKeysService} from './services/bin-keys.service';
import {MdAvailabilityService} from './services/mdAvailability.service';
import {AuthGuard} from './appSharedModule/guards/auth-guard.service';
import {HistoryService} from './services/history.service';
import {UnsavedChangesGuard} from './appSharedModule/guards/unsaved-changes-guard.service';
import {UtilsService} from './appSharedModule/services/utils.service';
import {SymbolsService} from './services/symbols.service';
import {TokenInterceptorService} from './authenticationModule/services/token-interceptor.service';
import {UserLoggedRolesServiceService} from './authenticationModule/services/user-logged-roles-service.service';
import {UserLoggedPermissionsService} from './authenticationModule/services/user-logged-permissions.service';
import {EtreeService} from './services/etree.service';
import {DadService} from './dad-reporting/services/dad.service';
import {CabinetService} from './hosting-manager/services/cabinet.service';
import {WorkVisitService} from './hosting-manager/services/work-visit.service';
import {CustomCompanyService} from './services/custom-company.service';
import {AnnouncementService} from './services/announcement.service';
import {GraphService} from './services/graph.service';
import {GraphHandlerService} from './components/bw-graph/graph-handler.service';
import {ClientUtilitiesService} from './services/client-utilities.service';
import {AwsService} from './services/aws.service';
import {CustomUserService} from './services/custom-user.service';
import {BwAvailabilityService} from './services/bwAvailability.service';
import {OrderFormService} from './services/order-form.service';
import {DocumentService} from './services/document.service';
import {TableService} from './services/table.service';
import {JiraService} from './services/jira.service';
import {XcoService} from './services/xco.service';
import {MapService} from './services/map.service';
import {ScheduleService} from './services/schedule.service';
import {PopService} from './services/pop.service';
import {SymbolDataDownloadLogService} from './services/symbol-data-download-log.service';
import {ManageInvoiceRecipientsService} from './services/manage-invoice-recipients.service';
import {UserUtilsService} from './services/user-utils.service';
import {MomentModule} from 'ngx-moment';
import {FloatLabelModule} from 'primeng/floatlabel';
import {TimeSyncComponent} from './components/time-sync/time-sync.component';
import {TimeSyncStatusPipe} from './share/pipes/time-sync-status.pipe';
import {TimeSyncMqttComponent} from './components/time-sync-mqtt/time-sync-mqtt.component';
import {TimeSyncProfileComponent} from './components/time-sync-profile/time-sync-profile.component';
import {TimeSyncService} from './services/timeSync.service';
import {
  MarketDataQfdMlrLatencyComponent
} from './components/bw-graph/market-data-qfd-mlr-latency/market-data-qfd-mlr-latency.component';
import {TechnicalPopService} from './services/technical-pop.service';
import {MarketDataQhfPlrLatencyGraphComponent} from './components/bw-graph/market-data-qhf-plr-latency-graph/market-data-qhf-plr-latency-graph.component';
import {AssignmentService} from './hosting-manager/services/assignment.service';
import {HostingManagerModule} from './hosting-manager/hosting-manager.module';
import {CryptoMonitoringComponent} from './components/crypto_monitoring/crypto-monitoring.component';
import {MarketDataLedgersComponent} from './components/market-data-ledgers/market-data-ledgers.component';
import {ClfLedgerComponent} from './components/clf-ledger/clf-ledger.component';
import {CryptoService} from './services/crypto.service';
import {ServiceDeliveryLocationsModule} from './components/service-delivery-locations/service-delivery-locations.module';
import {ConfirmPopupModule} from 'primeng/confirmpopup';
import {ChipsModule} from 'primeng/chips';

export function apiConfigFactory(): Configuration {
  const params: ConfigurationParameters = {
    basePath: environment.baseUrlWs,
    withCredentials: true,
  };
  return new Configuration(params);
}

@NgModule({
  declarations: [
    AppComponent,
    SideBarComponent,
    TopbarComponent,
    CartWidgetComponent,
    CartComponent,
    CartConfirmationComponent,
    CartAddpEditDialogComponent,
    BaseClientComponent,
    LoginComponent,
    HomeComponent,
    PageNotFoundComponent,
    LoaComponent,
    BwEtreeOverviewComponent,
    BwSchedulesComponent,
    QuestionableBooleanPipe,
    LongNumberPipe,
    QuincyEtreesListComponent,
    QuincyEtreeOverViewComponent,
    PopTrigramComponent,
    MdAvailabilityComponent,
    BwAvailabilityComponent,
    BwServiceMapComponent,
    MdServiceMapComponent,
    ServiceMapComponent,
    QedSymbolDataComponent,
    QedMulticastListComponent,
    QrdSymbolDataComponent,
    QrdMulticastListComponent,
    QrdProductInformationComponent,
    ImpersonateUserComponent,
    DownloadLogComponent,
    WeatherMapComponent,
    DocumentsComponent,
    DocumentCrudComponent,
    ChangePasswordComponent,
    AuthenticatorSetupComponent,
    NotAllowedPermissionsDirective,
    PasswordStrengthComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    EmailChangeConfirmationComponent,
    ListUsersComponent,
    RequestHistoricalDataComponent,
    UserCrudComponent,
    ListClientsComponent,
    ClientCrudComponent,
    EtreesCountersLiveComponent,
    CountersMqttComponent,
    ClientCrudComponent,
    DocumentNotificationComponent,
    DownloadDocumentComponent,
    ListUsersComponent,
    EncryptionKeysComponent,
    EncryptionKeysLogsComponent,
    QedProfileComponent,
    AnnouncementLogComponent,
    ListRecipientsComponent,
    AcknowledgedDomainConfirmationComponent,
    PGroupMultiselectComponent,
    ListRecipientsComponent,
    InformationComponent,
    BandwidthSummaryComponent,
    MarketDataSummaryComponent,
    AdminEncryptionKeysComponent,
    BwGraphListComponent,
    BwGraphCrudComponent,
    HistoricalDataRequestLogComponent,
    SymbolDataDownloadLogComponent,
    MfaComponent,
    MarketDataPlrLatencyGraphComponent,
    MarketDataQhfPlrLatencyGraphComponent,
    MarketDataQrdMlrLatencyComponent,
    MarketDataQfdMlrLatencyComponent,
    BwGraphEndToEndComponent,
    ManageInvoiceRecipientsComponent,
    MessageDialogComponent,
    ViewAnnouncementComponent,
    TimeSyncComponent,
    TimeSyncMqttComponent,
    TimeSyncStatusPipe,
    TimeSyncProfileComponent,
    CryptoMonitoringComponent,
    MarketDataLedgersComponent,
    ClfLedgerComponent
  ],
    imports: [
        AppSharedModule,
        AppRoutingModule,
        BrowserModule,
        FormsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        TableModule,
        ReactiveFormsModule,
        ApiModule.forRoot(apiConfigFactory),
        AppRoutingModule,
        CardModule,
        PanelModule,
        MultiSelectModule,
        DropdownModule,
        ButtonModule,
        CheckboxModule,
        FileUploadModule,
        SpinnerModule,
        FieldsetModule,
        TabViewModule,
        TabMenuModule,
        ChartModule,
        ToggleButtonModule,
        SelectButtonModule,
        RadioButtonModule,
        NgMultiSelectDropDownModule.forRoot(),
        SidebarModule,
        ToolbarModule,
        ProgressSpinnerModule,
        CalendarModule,
        InfiniteScrollModule,
        InputTextModule,
        EditorModule,
        NgMultiSelectDropDownModule,
        DadReportingModule,
        HostingManagerModule,
        DynamicDialogModule,
        TooltipModule,
        ConfirmDialogModule,
        NgxSpinnerModule,
        NgxDaterangepickerMd.forRoot(),
        OverlayPanelModule,
        CodeInputModule,
        PaginatorModule,
        MomentModule,
        FloatLabelModule,
        ServiceDeliveryLocationsModule,
        ConfirmPopupModule,
        TreeSelectModule,
        ChipsModule
    ],
  providers: [
    AuthenticationService,
    HistoryRequestService,
    BwGraphUserConfigsService,
    DatePipe,
    CompanyService,
    DialogService,
    ConfirmationService,
    CompanyService,
    RoleService,
    LoaService,
    BinKeysService,
    MdAvailabilityService,
    AuthGuard,
    HistoryService,
    UnsavedChangesGuard,
    UtilsService,
    AuthenticationService,
    SymbolsService,
    TokenInterceptorService,
    UserLoggedRolesServiceService,
    UserLoggedPermissionsService,
    EtreeService,
    DadService,
    CabinetService,
    AssignmentService,
    WorkVisitService,
    CustomCompanyService,
    AnnouncementService,
    GraphService,
    GraphHandlerService,
    ClientUtilitiesService,
    AwsService,
    CustomUserService,
    BwAvailabilityService,
    OrderFormService,
    DocumentService,
    TableService,
    JiraService,
    TechnicalPopService,
    XcoService,
    MapService,
    ScheduleService,
    PopService,
    SymbolDataDownloadLogService,
    ManageInvoiceRecipientsService,
    UserUtilsService,
    TimeSyncService,
    CryptoService,
  ],
  bootstrap: [AppComponent],
  exports: [
    BrowserModule,
    BrowserAnimationsModule,
    NotAllowedPermissionsDirective,
  ]
})
export class AppModule {
}
